import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  container: {
    width: "calc(100% - 30px)",
    margin: [1, 0],
    transition: "background 0.2s ease",
    background: props => (props.selected ? "#373737" : "#252525"),
    display: "flex",
    "flex-direction": "row",
    cursor: "pointer",
    "border-radius": 3,
    padding: 5,

    "&:hover": {
      background: "#373737",
    },
  },
  image: {
    width: 50,
    height: 50,
  },
  title: {
    "font-size": 16,
    "font-weight": "normal",
    margin: [4, 0, 0, 15],
  },
  subtitle: {
    "font-size": 12,
    margin: [0, 0, 0, 15],
  },
});

const SidebarItem = ({ onClick, image, title, subtitle, selected }) => {
  const classes = useStyles({ selected });

  return (
    <div onClick={onClick} className={classes.container}>
      <img src={image} alt={`${title} node icon`} className={classes.image} />
      <div>
        <h2 className={classes.title}>{title}</h2>
        <p className={classes.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};

export default SidebarItem;
